<template>
        <!-- MagicDoc -->
    <v-layout row wrap style="margin-top: 40px">
        <v-btn fab fixed color="warning" :loading="saveLoad" :disabled="saveLoad" @click.native="saveToDo()"><v-icon>mdi-content-save</v-icon></v-btn>
        <v-flex xs12 class="text-center">
            <h2 style="padding:20px">MagicDoc und Merkblatt</h2>
        </v-flex>
            <v-expansion-panels multiple>
                <v-expansion-panel>
                    <v-expansion-panel-header><h2>Schritt 1</h2></v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <v-layout row wrap>
                    <v-flex sm4>
                <!-- COLONNE 1 -->

                <!-- Déclaration incinération -->
                <v-list-item class="ml-n3">
                    <v-list-item-action>
                         <v-menu offset-y>
                            <template v-slot:activator="{on, attrs}">
                            <v-btn icon ripple v-on="on" v-bind="attrs">
                                <v-icon color="primary">mdi-file-document-edit</v-icon>
                            </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="magicDoc('declInc')">
                                    <v-list-item-title>Rechnungsstellung an Rechnungskontakt</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="magicDoc('declIncFactPF')">
                                    <v-list-item-title>Bei den Bestattungsunternehmen in Rechnung gestellt</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkDeclInc" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkDeclInc ? 'text-decoration:line-through' : ''">Einäscherungserklärung</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Procuration état civil -->
                <v-list-item class="ml-n3">
                    <v-list-item-action>
                    <v-btn icon ripple @click="magicDoc('procuration')">
                        <v-icon color="primary">mdi-file-document-edit</v-icon>
                    </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkProcuEC" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkProcuEC ? 'text-decoration:line-through' : ''">Vollmacht Zivilstandesamt</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
                <!-- Avis mortuaire -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkAvisMortuaire" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkAvisMortuaire ? 'text-decoration:line-through' : ''">Todesanzeige</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Lieu cérémonie -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkLieuCeremonie" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkLieuCeremonie ? 'text-decoration:line-through' : ''">Ort der Zeremonie</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
                </v-flex>
                <v-flex sm4>
                <!-- COLONNE 2 -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkCelebrant" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkCelebrant ? 'text-decoration:line-through' : ''">Pfarrer, Trauerredner</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
                <!-- Cimetière inhum croix -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkCimInhum" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkCimInhum ? 'text-decoration:line-through' : ''">Friedhof, Erdbestattung, Kreuz</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>


                <!-- Fleurs -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkFleurs" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkFleurs ? 'text-decoration:line-through' : ''">Blumen</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
                <!-- Journaux -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkJournaux" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkJournaux ? 'text-decoration:line-through' : ''">Zeitungen</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- COLONNE 3 -->
                </v-flex>
                <v-flex sm4>
                
                <!-- Concession droit d'entrée -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkConcession" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkConcession ? 'text-decoration:line-through' : ''">Konzession, Eintrittsgebühr Friedhof</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
                <!-- Crématoire -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkPhoto" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkPhoto ? 'text-decoration:line-through' : ''">Foto</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
                
                <!-- Cimetière inhum. cendres croix -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkCimInhumCendres" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkCimInhumCendres ? 'text-decoration:line-through' : ''">Friedhof, Urnenbeisetzung, Kreuz</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                </v-flex>
                </v-layout>
                </v-expansion-panel-content>
                </v-expansion-panel>






                <v-expansion-panel>
                    <v-expansion-panel-header><h2>Schritt 2</h2></v-expansion-panel-header>
                    <v-expansion-panel-content>
                <v-layout row wrap>
                <v-flex sm2>
                <!-- Carte registre -->
                <v-list-item>
                    <v-list-item-action>
                        <v-menu offset-y>
                            <template v-slot:activator="{on, attrs}">
                            <v-btn icon ripple v-on="on" v-bind="attrs">
                                <v-icon color="primary">mdi-file-document-edit</v-icon>
                            </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="magicCarte('petiteCarte')">
                                    <v-list-item-title>Erstellen im .pdf</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="magicDocxCarte('petiteCarte')">
                                    <v-list-item-title>Erstellen im .docx</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    Kleine Karte
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-action>
                    <v-menu offset-y>
                            <template v-slot:activator="{on, attrs}">
                            <v-btn icon ripple v-on="on" v-bind="attrs">
                                <v-icon color="primary">mdi-file-document-edit</v-icon>
                            </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="magicCarte('grandeCarte')">
                                    <v-list-item-title>Erstellen im .pdf</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="magicDocxCarte('grandeCarte')">
                                    <v-list-item-title>Erstellen im .docx</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    Grosse Karte
                    </v-list-item-content>
                </v-list-item>
                    <v-list-item>
                    <v-list-item-action>
                    <v-btn icon ripple @click="magicRegistre()">
                        <v-icon color="primary">mdi-file-document-edit</v-icon>
                    </v-btn>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    Kondolenzbuch
                    </v-list-item-content>
                </v-list-item>
                </v-flex>

                <v-flex sm4>
                <!-- Cartes, registre, déco cercueil -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkCarteReg" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkCarteReg ? 'text-decoration:line-through' : ''">Karten, Kondolenzbuch, Sargdekoration</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- Certificat d'inscription E.C. -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkCertificatEC" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkCertificatEC ? 'text-decoration:line-through' : ''">Bestätigung der Anmeldung Zivilstandesamt</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- Envoyé papiers E.C. -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkEnvPapiersEC" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkEnvPapiersEC ? 'text-decoration:line-through' : ''">Papiere verschickt an das Zivilstandesamt</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                </v-flex>

                <v-flex sm2>
                <!-- Avis Décès -->
                <v-list-item>
                    <v-list-item-action>
                    <v-btn icon ripple @click="magicDoc('avisDeces')">
                        <v-icon color="primary">mdi-file-document-edit</v-icon>
                    </v-btn>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    Todesbescheinigung
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                </v-list-item>
                <!-- Avis Inc -->
                <v-list-item>
                    <v-list-item-action>
                    <v-btn icon ripple @click="magicDoc('avisInc')">
                        <v-icon color="primary">mdi-file-document-edit</v-icon>
                    </v-btn>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    Protokol der Einäscherung
                    </v-list-item-content>
                </v-list-item>
                </v-flex>

                <v-flex sm4>
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkAvisDecesCure" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkAvisDecesCure ? 'text-decoration:line-through' : ''">Pfarrei</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkAvisDecesCommune" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkAvisDecesCommune ? 'text-decoration:line-through' : ''">Gemeinde</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkAvisDecesCrematoire" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkAvisDecesCrematoire ? 'text-decoration:line-through' : ''">Krematorium</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                </v-flex>
                </v-layout>
                </v-expansion-panel-content>
                </v-expansion-panel>





                <v-expansion-panel>
                    <v-expansion-panel-header><h2>Schritt 3</h2></v-expansion-panel-header>
                    <v-expansion-panel-content>
                <v-layout row wrap>
                 <v-flex sm4>

                <!-- Livret de Famille -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkLivretFamille" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkLivretFamille ? 'text-decoration:line-through' : ''">Familienbüchlein</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Acte de décès -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkActeDeces" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkActeDeces ? 'text-decoration:line-through' : ''">Todesurkunde</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Retrait des cendres et mise en urne -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkRetraitCendres" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkRetraitCendres ? 'text-decoration:line-through' : ''">Abholung der Asche im Krematorium</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                </v-flex>
                <v-flex sm4>

                <!-- Remerciements journal le ... -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkRemerJournal" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content class="ml-3 pa-0" style="width:100px">
                    <v-list-item-title :style="todo.checkRemerJournal ? 'text-decoration:line-through' : ''">Danksagung Zeitung</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content class="ma-n1 pa-0">
                    <v-text-field class="pa-0 ma-0" v-if="todo.checkRemerJournal" type="date" v-model="todo.dateRemerJournal"></v-text-field>
                    </v-list-item-content>
                </v-list-item>

                <!-- Remerciements cartes -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkRemerCartes" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content  class="ml-3">
                    <v-list-item-title :style="todo.checkRemerCartes ? 'text-decoration:line-through' : ''">Danksagungskarten</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Remise des cendres le ... -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkRemiseCendres" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content class="ml-3" style="width:100px">
                    <v-list-item-title :style="todo.checkRemiseCendres ? 'text-decoration:line-through' : ''">Abgabe der Asche</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content  class="ml-3">
                    <!-- <v-text-field v-if="checkRemiseCendres" type="date" v-model="dateRemiseCendres"></v-text-field> -->
                    </v-list-item-content>
                </v-list-item>
                </v-flex>
                <v-flex sm4>

                <!-- Facturé le ... -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkFacture" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content class="ml-3" style="width:100px">
                    <v-list-item-title :style="todo.checkFacture ? 'text-decoration:line-through' : ''">Rechnung</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content class="ma-n1 pa-0">
                    <v-text-field class="pa-0 ma-0" v-if="todo.checkFacture" type="date" v-model="todo.dateFacture"></v-text-field>
                    </v-list-item-content>
                </v-list-item>

                <!-- Payé le ... -->
                <v-list-item>
                    <v-list-item-action>
                        <div></div>
                    </v-list-item-action>
                    <v-list-item-action>
                    <v-switch v-model="todo.checkPaye" color="orange"></v-switch>
                    </v-list-item-action>
                    <v-list-item-content class="ml-3" style="width:100px">
                    <v-list-item-title :style="todo.checkPaye ? 'text-decoration:line-through' : ''">Bezahlt</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content class="ma-n1 pa-0">
                    <v-text-field class="pa-0 ma-0" v-if="todo.checkPaye" type="date" v-model="todo.datePaye"></v-text-field>
                    </v-list-item-content>
                </v-list-item>

                </v-flex>
                </v-layout>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-flex xs12 class="text-center">
                <v-btn class="mr-2" large color="primary" :loading="saveLoad" :disabled="saveLoad" @click="saveToDo()">Speichern</v-btn>
                <v-btn class="mr-2" v-if="showButtonImprimer" large color="primary" @click="magicRecap()">zu drucken</v-btn>
                <v-btn v-if="showButtonImprimer" large color="primary" @click="magicRecapFamille()">Familienübersicht drucken</v-btn>
            </v-flex>

    <v-snackbar :timeout="3000" success v-model="snackbar">Speicherung erfolgreich !</v-snackbar>
    </v-layout>
</template>
<script>
    import {ajax_post} from '../../public/global.js'
    export default {
      data(){
        return{
            todo: {
                checkDeclInc: false,
                checkProcuEC: false,
                checkAvisMortuaire: false,
                checkLieuCeremonie: false,
                checkCelebrant: false,
                checkCimInhum: false,
                checkFleurs: false,
                checkJournaux: false,
                checkConcession: false,
                checkPhoto: false,
                checkCertificatEC: false,
                checkEnvPapiersEC: false,
                checkCimInhumCendres: false,
                checkCarteReg: false,
                checkAvisDecesCure: false,
                checkAvisDecesCommune: false,
                checkAvisDecesCrematoire: false,
                checkLivretFamille: false,
                checkActeDeces: false,
                checkRetraitCendres: false,
                checkRemiseCendres: false,
                dateRemiseCendres: '',
                checkRemerCartes: false,
                checkRemerJournal: false,
                dateRemerJournal: '',
                checkFacture: false,
                dateFacture: '',
                checkPaye: false,
                datePaye: ''
            },
          saveLoad: false,
          snackbar: false,
          showButtonImprimer: false
        }
      },
      methods: {
        fetchData () {
            ajax_post(`/PHP/ajax/saveToDo.php`, `idDefunt=${this.$route.params.id}&token=${this.$token()}&choice=return`).then((response)=>{
                let rep = JSON.parse(response)
                if(!rep.error){
                  let toDoRecup = rep.data
                  this.todo.checkDeclInc = toDoRecup.decl_inc == 1 ? true : false
                  this.todo.checkProcuEC = toDoRecup.procu_ec == 1 ? true : false
                  this.todo.checkAvisMortuaire = toDoRecup.avis_mortuaire == 1 ? true : false
                  this.todo.checkLieuCeremonie = toDoRecup.lieu_ceremonie == 1 ? true : false
                  this.todo.checkCelebrant = toDoRecup.celebrant == 1 ? true : false
                  this.todo.checkCimInhum = toDoRecup.cim_inhum == 1 ? true : false
                  this.todo.checkFleurs = toDoRecup.fleurs == 1 ? true : false
                  this.todo.checkJournaux = toDoRecup.journaux == 1 ? true : false
                  this.todo.checkConcession = toDoRecup.concession == 1 ? true : false
                  this.todo.checkPhoto = toDoRecup.photo == 1 ? true : false
                  this.todo.checkCertificatEC = toDoRecup.certificat_ec == 1 ? true : false
                  this.todo.checkEnvPapiersEC = toDoRecup.env_papiers_ec == 1 ? true : false
                  this.todo.checkCimInhumCendres = toDoRecup.cim_inhum_cendres == 1 ? true : false
                  this.todo.checkCarteReg = toDoRecup.carte_reg == 1 ? true : false
                  this.todo.checkAvisDecesCure = toDoRecup.avis_deces_cure == 1 ? true : false
                  this.todo.checkAvisDecesCommune = toDoRecup.avis_deces_commune == 1 ? true : false
                  this.todo.checkAvisDecesCrematoire = toDoRecup.avis_deces_crematoire == 1 ? true : false
                  this.todo.checkLivretFamille = toDoRecup.livret_famille == 1 ? true : false
                  this.todo.checkActeDeces = toDoRecup.acte_deces == 1 ? true : false
                  this.todo.checkRetraitCendres = toDoRecup.retrait_cendres == 1 ? true : false
                  this.todo.checkRemiseCendres = toDoRecup.remise_cendres == 1 ? true : false
                  this.todo.dateRemiseCendres = toDoRecup.date_remise_cendres
                  this.todo.checkRemerCartes = toDoRecup.remer_cartes == 1 ? true : false
                  this.todo.checkRemerJournal = toDoRecup.remer_journal == 1 ? true : false
                  this.todo.dateRemerJournal = toDoRecup.date_remer_journal
                  this.todo.checkFacture = toDoRecup.facture == 1 ? true : false
                  this.todo.dateFacture = toDoRecup.date_facture
                  this.todo.checkPaye = toDoRecup.paye == 1 ? true : false
                  this.todo.datePaye = toDoRecup.date_paye
                }else{
                    this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                }
            })
        },
        saveNext(){
        this.saveLoad = true
            ajax_post(`/PHP/ajax/saveToDo.php`, `token=${this.$token()}&choice=save&idDefunt=${this.$route.params.id}&declInc=${this.todo.checkDeclInc}&procuEC=${this.todo.checkProcuEC}&avisMortuaire=${this.todo.checkAvisMortuaire}&lieuCeremonie=${this.todo.checkLieuCeremonie}&celebrant=${this.todo.checkCelebrant}&cimInhum=${this.todo.checkCimInhum}&fleurs=${this.todo.checkFleurs}&journaux=${this.todo.checkJournaux}&concession=${this.todo.checkConcession}&photo=${this.todo.checkPhoto}&certificatEC=${this.todo.checkCertificatEC}&envPapiersEC=${this.todo.checkEnvPapiersEC}&cimInhumCendres=${this.todo.checkCimInhumCendres}&carteReg=${this.todo.checkCarteReg}&avisDecesCure=${this.todo.checkAvisDecesCure}&avisDecesCommune=${this.todo.checkAvisDecesCommune}&avisDecesCrematoire=${this.todo.checkAvisDecesCrematoire}&livretFamille=${this.todo.checkLivretFamille}&acteDeces=${this.todo.checkActeDeces}&retraitCendres=${this.todo.checkRetraitCendres}&remiseCendres=${this.todo.checkRemiseCendres}&dateRemiseCendres=${this.todo.dateRemiseCendres}&remerCartes=${this.todo.checkRemerCartes}&remerJournal=${this.todo.checkRemerJournal}&dateRemerJournal=${this.todo.dateRemerJournal}&facture=${this.todo.checkFacture}&dateFacture=${this.todo.dateFacture}&paye=${this.todo.checkPaye}&datePaye=${this.todo.datePaye}`).then((response)=>{
                let rep = JSON.parse(response)
                if(!rep.error){
                    this.saveLoad = false
                    this.$root.$emit('myinfo', {title: "Serenity", msg: "Erfolgreich gespeichert !", color: ""})
                    this.showButtonImprimer = true
                }else{
                  this.saveLoad = false
                  this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                }
            })
        },
        magicDoc(doc){
          // window.open("./pdf/magicDoc.php?doc=" + doc + "&sexe=" + this.defunt.sexe + "&dateDeces=" + this.defunt.date_deces + "&lieuDeces=" + this.defunt.lieu_deces + "&nom=" + this.defunt.nom + "&prenom=" + this.defunt.prenom + "&lieuNaiss=" + this.defunt.lieu_naissance + "&dateNaiss=" + this.defunt.date_naissance + "&origine=" + this.defunt.lieu_origine + "&domicile=" + this.defunt.localite + "&filiation=" + this.defunt.filiation + "&etatCivil=" + this.defunt.etat_civil, "_blank")
          window.open("/PHP/pdf/magicDoc.php?doc=" + doc + "&token=" + this.$token() +"&idDefunt=" + this.$route.params.id, "_blank")
        },
        magicCarte(doc){
          window.open("/PHP/pdf/magicCarte.php?doc=" + doc + "&token=" + this.$token() + "&idDefunt=" + this.$route.params.id, "_blank")
        },
        magicRegistre(){
          window.open("/PHP/pdf/magicRegistre.php?&idDefunt=" + this.$route.params.id + "&token=" + this.$token(), "_blank")
        },
        magicRecap(){
          window.open("/PHP/pdf/magicRecap.php?&idDefunt=" + this.$route.params.id + "&token=" + this.$token(), "_blank")
        },
        magicRecapFamille(){
          window.open("/PHP/pdf/magicRecapFamille.php?&idDefunt=" + this.$route.params.id + "&token=" + this.$token(), "_blank")
        },
        magicDocxCarte(taille){
             window.open("/PHP/docx/cartesChapelle.php?idDefunt=" + this.$route.params.id + "&token=" + this.$token() + "&taille=" + taille)
         },
        saveToDo(){
          setTimeout(() => {
            this.saveNext()
          }, 0)
        }
      },
      created () {
        this.fetchData()
      },
      watch: {
        '$route': 'fetchData',
        'todo': {
              handler: function(){
                this.showButtonImprimer = false
              },
              deep: true
          }
      }
    }
</script>